import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }

  async unfurl({ detail: { url, replaceLinkWith } }) {
    const response = await fetch(`${this.urlValue}?${new URLSearchParams({ url })}`, {
      headers: { Accept: 'application/json' }
    })
    if (!response.ok) return

    const { title } = await response.json()
    if (title) replaceLinkWith(this.#link(url, title))
  }

  #link(url, title) {
    const link = document.createElement('a')
    link.href = url
    link.textContent = title
    return link.outerHTML
  }
}
